<template>
  <!-- 数据统计列表 -->
  <div class="bigcontent columnFlx">
    <div
      style="
        display: flex;
        justify-content: space-between;
        background: #fff;
        padding: 20px;
      "
    >
      <div style="display: flex; width: 80%">
        <div style="display: flex; align-items: center">
          <span style="white-space: nowrap; font-size: 14px; margin-right: 5px"
            >问卷名称:</span
          >
          <el-input
            type="text"
            v-model="queryParams.questionnaireName"
            placeholder="单行输入"
          ></el-input>
        </div>

        <div
          style="display: flex; align-items: center; margin-left: 15px"
          class="my_input"
        >
          <span style="white-space: nowrap; font-size: 14px; margin-right: 5px"
            >发布状态:</span
          >
          <el-select v-model="queryParams.releaseStatus" placeholder="请选择">
            <el-option
              v-for="item in stateDic"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <!-- <el-select
            v-model="queryParams.releaseStatus"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in stateDic"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select> -->
        </div>
      </div>
      <div>
        <el-button @click="getListReset">重置</el-button>
        <el-button type="primary" @click="getDataOne">查询</el-button>
      </div>
    </div>
    <div class="content">
      <el-table
        :data="tableData"
        style="width: 100%"
        header-align="center"
        :border="true"
        :header-cell-style="{ background: '#F6F7FA' }"
        :cell-style="{ background: '#ffffff' }"
        :empty-text="tableLoading ? '加载中' : '暂无数据'"
      >
        <el-table-column
          prop="questionnaireName"
          label="问卷名称"
          width="400px"
          align="left"
          class-name="custom-questionnaire-column"
        >
          <template slot-scope="scope">
            <p
              style="color: #1877ff; cursor: pointer"
              @click="goDetail(scope.row)"
            >
              【{{
                scope.row.releaseStatus == 0
                  ? "草稿"
                  : scope.row.releaseStatus == 1
                  ? "已发布"
                  : "未发布"
              }}】 {{ scope.row.questionnaireName }}
            </p>
          </template>
        </el-table-column>
        <el-table-column
          prop="questionnaireType"
          label="类型"
          width="auto"
          align="center"
        >
          <template slot-scope="scope">
            {{
              scope.row.questionnaireType == 1
                ? "问卷"
                : scope.row.questionnaireType == 2
                ? "考试"
                : "测评"
            }}
          </template>
        </el-table-column>
        <el-table-column
          prop="dataNum"
          label="参与人数"
          width="auto"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="questionNum"
          label="题目数量"
          width="auto"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="browseNum"
          label="浏览数量"
          width="auto"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="dataNum"
          label="回收总量"
          width="auto"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="avgAnswerTime"
          label="平均答题时间"
          width="auto"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.avgAnswerTime }}秒
          </template>
        </el-table-column>
        <!-- 新增：是否绑定腾讯文档列 -->
        <el-table-column label="绑定腾讯文档" width="auto" align="center">
          <template slot-scope="scope">
            {{ scope.row.tencentDocFileId ? "是" : "否" }}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" align="center">
        </el-table-column>
        <!-- .releaseStatus == 1 已发布、、未发布 -->

        <!-- <el-button type="text" size="small">
                            统计导出
                        </el-button> -->
        <!-- <el-table-column label="操作" width="150" align="center">
          <template slot-scope="scope">
            
            <el-button @click="goDetail(scope.row)" type="text" size="small">
              详情
            </el-button>
            <el-button
              type="text"
              size="small"
              @click="handleExportClick(scope.row)"
            >
              数据导出
            </el-button>
          </template>
        </el-table-column> -->
        <el-table-column label="操作" width="180" align="center">
          <template slot-scope="scope">
            <el-button @click="goDetail(scope.row)" type="text" size="small">
              详情
            </el-button>

            <el-dropdown trigger="click">
              <el-button type="text" size="small">
                数据导出<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  @click.native="handleExportClick(scope.row, '数据文件')"
                >
                  导出数据文件
                </el-dropdown-item>
                <el-dropdown-item
                  @click.native="handleExportClick(scope.row, '腾讯文档')"
                >
                  导出腾讯文档
                </el-dropdown-item>
                <el-dropdown-item
                  @click.native="handleExportClick(scope.row, '飞书文档')"
                >
                  导出飞书文档
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          background
          layout="prev, pager, next"
          :page-size="queryParams.pageSize"
          :current-page="currentPage"
          :total="total"
          @current-change="handlePageChange"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog title="分享" :visible.sync="dialogVisible" width="800px">
      <div style="display: flex; padding: 40px; background: #fff">
        <div
          class="left-panel"
          style="
            background-image: url('https://ai-public.mastergo.com/ai/img_res/c85e4dd3c85760773fb9d40f30d1914a.jpg');
            background-size: 100% 100%;
          "
        >
          <div class="card">
            <h2 class="card-title">测试_副本</h2>
            <img :src="clickItem.qrCode" alt="二维码" class="qr-code" />
          </div>
        </div>
        <!-- 右侧信息区 -->
        <div class="right-panel">
          <div class="info-box">
            <h2 class="info-title">问卷信息</h2>
            <p class="info-item">问卷名称: {{ clickItem.questionnaireName }}</p>
            <p class="info-item">
              问卷备注: {{ clickItem.questionnaireDescribe }}
            </p>
          </div>

          <div class="link-box">
            <h2 class="link-title">问卷链接</h2>
            <div
              style="
                width: 100%;
                border: solid 1px #efefef;
                padding: 4px;
                height: 40px;
              "
            >
              <input
                type="text"
                style="width: 100%; height: 40px"
                readonly
                :value="clickItem.qrCode"
              />
            </div>

            <div class="btn-group">
              <button class="btn" @click="copyClick">复制链接</button>
              <button class="btn" @click="downs">下载图片</button>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      :title="verifyTitle"
      :visible.sync="dialogVerifyVisible"
      width="380px"
      @close="onCloseVerifyDialog"
    >
      <div class="visibleContent">
        我们已为您打开腾讯文档授权页面，请在新页面中完成微信扫码授权。如您已完成授权或需要重新操作，请点击下方按钮刷新页面查看最新状态。
      </div>
      <div class="visibleBotton">
        <div class="button" @click="onCloseVerifyDialog">取消</div>
        <div class="button" @click="onCloseVerifyDialog">已完成授权</div>
      </div>
    </el-dialog>

    <el-dialog
      :title="tencentTitle"
      :visible.sync="dialogTencentVisible"
      width="380px"
      @close="onCloseTencentDialog"
    >
      <div class="tencentOptionList" v-if="optionShow">
        <span
          style="
            text-align: center;
            font-size: 12px;
            color: #afb0b2;
            padding-bottom: 15px;
          "
          v-if="tencentDocsExpiry != ''"
          >腾讯文档授权到期时间：{{ tencentDocsExpiry }}</span
        >
        <div
          class="item"
          :class="{ active: selectedOption === 'new' }"
          @click="toggleOption('new')"
        >
          <img src="@/assets/images/new.svg" />
          添加至新建文档
        </div>
        <div
          class="item"
          :class="{ active: selectedOption === 'old' }"
          @click="toggleOption('old')"
        >
          <img src="@/assets/images/old.svg" />
          添加至已有文档
        </div>
        <div
          class="button"
          :class="{ disabled: optionConfirmDisabled }"
          @click="!optionConfirmDisabled && optionConfirm()"
        >
          确定
        </div>
        <div class="exit" @click="optionExit">退出腾讯文档</div>
      </div>
      <div class="tencentList" v-if="listShow">
        <div class="list">
          <span
            style="
              display: block;
              text-align: center;
              font-size: 12px;
              color: #afb0b2;
              padding-bottom: 15px;
            "
          >
            选择文档导出后，该问卷活动会自动绑定此在线文档，在授权有效期内收集的数据会自动更新同步到在线文档中
          </span>
          <div v-if="allList.length > 0">
            <div
              class="item"
              v-for="item in allList"
              :key="item.ID"
              @click="selected = item.ID"
            >
              <div class="left">
                <img src="@/assets/images/document.svg" class="icon" />
                <div class="text">
                  <div class="title">{{ item.title }}</div>
                  <div class="time">{{ formatTimestamp(item.createTime) }}</div>
                </div>
              </div>
              <el-radio-group v-model="selected">
                <el-radio :label="item.ID"></el-radio>
              </el-radio-group>
            </div>
          </div>

          <div v-else class="no-data">暂无数据</div>
        </div>

        <div v-if="hasMore" class="more">
          <el-button
            type="primary"
            size="mini"
            :loading="loading"
            @click="loadMore"
          >
            {{ loading ? "加载中..." : "加载更多" }}
          </el-button>
        </div>
        <div
          class="button"
          :class="{ disabled: listConfirmDisabled }"
          @click="!listConfirmDisabled && listConfirm()"
        >
          确定
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :title="verifyTitle"
      :visible.sync="dialogVerifyVisibleFeiShu"
      width="380px"
      @close="onCloseVerifyDialogFeiShu"
    >
      <div class="visibleContent">
        我们已为您打开飞书文档授权页面，请在新页面中完成飞书扫码授权。如您已完成授权或需要重新操作，请点击下方按钮刷新页面查看最新状态。
      </div>
      <div class="visibleBotton">
        <div class="button" @click="onCloseVerifyDialogFeiShu">取消</div>
        <div class="button" @click="onCloseVerifyDialogFeiShu">已完成授权</div>
      </div>
    </el-dialog>

    <el-dialog
      :title="tencentTitle"
      :visible.sync="dialogFeiShuVisible"
      width="380px"
      @close="onCloseTencentDialogFeiShu"
    >
      <div class="tencentOptionList" v-if="optionShowFeiShu">
        <span
          style="
            text-align: center;
            font-size: 12px;
            color: #afb0b2;
            padding-bottom: 15px;
          "
          v-if="feishuDocsExpiry != ''"
        >
          飞书文档授权到期时间：{{ feishuDocsExpiry }}
        </span>
        <div
          class="item"
          :class="{ active: selectedOptionFeiShu === 'new' }"
          @click="toggleOptionFeiShu('new')"
        >
          <img src="@/assets/images/new.svg" />
          添加至新建文档
        </div>
        <div
          class="item"
          :class="{ active: selectedOptionFeiShu === 'old' }"
          @click="toggleOptionFeiShu('old')"
        >
          <img src="@/assets/images/old.svg" />
          添加至已有文档
        </div>
        <div
          class="button"
          :class="{ disabled: optionConfirmDisabledFeiShu }"
          @click="!optionConfirmDisabledFeiShu && optionConfirmFeiShu()"
        >
          确定
        </div>
        <div class="exit" @click="optionFeiShuExit">退出飞书文档</div>
      </div>
      <div class="tencentList" v-if="listShowFeiShu">
        <div class="list">
          <span
            style="
              display: block;
              text-align: center;
              font-size: 12px;
              color: #afb0b2;
              padding-bottom: 15px;
            "
          >
            选择文档导出后，该问卷活动会自动绑定此在线文档，在授权有效期内收集的数据会自动更新同步到在线文档中
          </span>
          <div v-if="allListFeiShu.length > 0">
            <div
              class="item"
              v-for="item in allListFeiShu"
              :key="item.ID"
              @click="selectedFeiShu = item.ID"
            >
              <div class="left">
                <img src="@/assets/images/document.svg" class="icon" />
                <div class="text">
                  <div class="title">{{ item.name }}</div>
                  <div class="time">
                    {{ formatTimestamp(item.created_time) }}
                  </div>
                </div>
              </div>
              <el-radio-group v-model="selectedFeiShu">
                <el-radio :label="item.token"></el-radio>
              </el-radio-group>
            </div>
          </div>

          <div v-else class="no-data">暂无数据</div>
        </div>

        <div v-if="hasMoreFeiShu" class="more">
          <el-button
            type="primary"
            size="mini"
            :loading="loading"
            @click="loadMoreFeiShu"
          >
            {{ loading ? "加载中..." : "加载更多" }}
          </el-button>
        </div>
        <div
          class="button"
          :class="{ disabled: listConfirmDisabledFeiShu }"
          @click="!listConfirmDisabledFeiShu && listConfirmFeiShu()"
        >
          确定
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import { templateList, infoFreeze, convertTemplate } from "@/api/userManagement/index";
import {
  userList,
  usercloseQuestionnaire,
  closeQuestionnaire,
  copyQuestionnaire,
  exportData,
  getOauth,
  createByUuid,
  files,
  appendByUuid,
  exit,
  getUserInfo,
  getConfiguration,
  getFeiShuConfiguration,
  getFeiShuOauth,
  exitFeiShu,
  createByUuidFeiShu,
  filesFeiShu,
  appendByUuidFeiShu,
} from "@/api/index.js";
import { name } from "file-loader";
export default {
  dicts: ["sys_job_status"],
  data() {
    return {
      dialogVisible: false,
      tableData: [],
      clickItem: {},
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        userKey: "",
        questionnaireName: "",
        releaseStatus: "",
      },
      dateRange: [],
      form: {
        id: "",
        dealInfo: "",
      },
      total: 0,
      currentPage: 1,
      isAddShow: false,
      islookShow: false,
      input: "",
      dataOne: "",
      peopleID: "",
      stateDic: [
        {
          label: "所有",
          value: "",
        },
        {
          label: "已发布",
          value: "1",
        },
        {
          label: "未发布",
          value: "0",
        },
      ],
      tencentTitle: "添加",
      code: "",
      state: "",
      dialogTencentVisible: false,
      tencentItem: {},
      optionShow: true,
      listShow: false,
      selected: "",
      allList: [],
      start: 0,
      hasMore: true,
      loading: false,
      selectedOption: "",
      tableLoading: false,
      optionConfirmDisabled: false,
      listConfirmDisabled: false,
      verifyTitle: "授权操作提示",
      dialogVerifyVisible: false,
      dialogFeiShuVisible: false,
      optionConfirmDisabledFeiShu: false,
      selectedOptionFeiShu: "",
      startFeiShu: 0,
      hasMoreFeiShu: true,
      allListFeiShu: [],
      loadingFeiShu: false,
      selectedFeiShu: "",
      dialogVerifyVisibleFeiShu: false,
      feiShuItem: {},
      listCinfirmDisabledFeiShu: false,
      tencentDocFileId: "",
      feishuDocFileId: "",
      tencentDocsExpiry: "",
      feishuDocsExpiry: "",
      optionShowFeiShu: false,
      listShowFeiShu: false,
    };
  },
  created() {
    window.addEventListener("keyup", this.enterSearchOrder);
    // console.log(localStorage.getItem("token"),'localStorage.getItem("token")');

    this.tencentDocsExpiry = localStorage.getItem("tencentDocsExpiry");
    this.feishuDocsExpiry = localStorage.getItem("feishuDocsExpiry");

    const urlParams = new URLSearchParams(window.location.search);
    this.code = urlParams.get("code") || "";
    this.state = urlParams.get("state") || "";
    this.type = urlParams.get("type") || "";

    if (this.code) {
      console.log("授权 code:", this.code);
      if (this.type == "feishu") {
        //飞书文档认证
        getFeiShuOauth({
          code: this.code,
          state: this.state,
        })
          .then((res) => {
            if (res.code === 200) {
              console.log("res", res);
              getUserInfo(localStorage.getItem("token"))
                .then((res) => {
                  this.nickname = res.data.nickname;
                  localStorage.setItem("nickname", res.data.nickname);
                  localStorage.setItem("ifFeiShuDocs", res.data.ifFeiShuDocs);
                  localStorage.setItem(
                    "feishuDocsExpiry",
                    res.data.feishuDocsExpiry,
                  );
                })
                .catch((err) => {
                  console.log("err", err);
                });
            }
          })
          .catch((err) => {
            console.log("err", err);
          });
      } else {
        //腾讯文档认证
        getOauth({
          code: this.code,
        })
          .then((res) => {
            if (res.code === 200) {
              console.log("res", res);
              getUserInfo(localStorage.getItem("token"))
                .then((res) => {
                  this.nickname = res.data.nickname;
                  localStorage.setItem("nickname", res.data.nickname);
                  localStorage.setItem("ifTencentDocs", res.data.ifTencentDocs);
                  localStorage.setItem(
                    "tencentDocsExpiry",
                    res.data.tencentDocsExpiry,
                  );
                })
                .catch((err) => {
                  console.log("err", err);
                });
            }
          })
          .catch((err) => {
            console.log("err", err);
          });
      }
    }
  },
  mounted() {
    this.queryParams.userKey = this.$route.query.peopleID;
    console.log(this.peopleID, "this.peopleID");
    this.getData();
  },
  methods: {
    formatTimestamp(timestamp) {
      if (!timestamp) return "";
      const date = new Date(timestamp * 1000); // 乘以1000是因为JavaScript的Date需要毫秒级时间戳
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    beforeHandleCommand(index, row, command) {
      return {
        index: index,
        row: row,
        command: command,
      };
    },

    handleCommand(command) {
      switch (command.command) {
        case "数据统计": //数据统计
          break;
        case "重新编辑": //重新编辑
          break;
        case "创建副本": //创建副本
          this.copyMethod(command.index, command.row);
          break;
        case "结束问卷": //结束问卷
          this.endMethod(command.index, command.row);
          break;
      }
    },
    // 创建副本
    copyMethod(index, item) {
      console.log(item, "item");

      copyQuestionnaire({
        uuid: item.uuid,
      })
        .then((res) => {
          if (res.code === 200) {
            this.getData();
            this.$message.closeAll();
            this.$message({
              message: "成功",
              type: "success",
            });
          } else {
            this.$message.closeAll();
            this.$message({
              message: res.msg,
              type: "failed",
            });
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    },
    // 结束问卷
    endMethod(index, item) {
      console.log(item, "item");
      closeQuestionnaire({
        uuid: item.uuid,
      })
        .then((res) => {
          if (res.code === 200) {
            this.getData();
            this.$message.closeAll();
            this.$message({
              message: "成功",
              type: "success",
            });
          } else {
            this.$message.closeAll();
            this.$message({
              message: res.msg,
              type: "failed",
            });
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    },
    // 重置
    getListReset() {
      // this.dateRange = []
      this.queryParams.releaseStatus = null;
      this.queryParams.questionnaireName = null;
      this.queryParams.userKey = null;
      this.currentPage = 1;
      this.queryParams.pageNum = 1;

      this.getData();
    },
    // 回车事件
    enterSearchOrder: function (e) {
      if (e.keyCode === 13) {
        this.queryParams.pageNum = 1;
        this.getData(); //这里的操作，是回车之后想要进行的操作，尽量全部写在一个方法里面
      }
    },
    getDataOne() {
      this.queryParams.pageNum = 1;
      this.currentPage = 1;
      this.getData();
    },
    // 查询数据
    getData() {
      this.tableLoading = true;
      userList({
        releaseStatus: this.queryParams.releaseStatus,
        pageNum: this.currentPage,
        questionnaireName: this.queryParams.questionnaireName,
        questionnaireType: "",
      })
        .then((response) => {
          this.tableData = response.rows;
          this.total = response.total;
        })
        .catch((err) => {
          console.log("err", err);
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.queryParams.pageNum = 1;
      this.getData();
    },
    handleCurrentChange(val) {
      this.queryParams.pageNum = val;
      this.getData();
    },

    handlePageChange(page) {
      this.currentPage = page;
      this.queryParams.pageNum = page;
      // 这里可以添加获取新页数据的逻辑
      console.log("切换到页码:", page);
      this.getData();
    },
    // 查看详情
    goDetail(item) {
      console.log(item, "item");
      this.$router.push({
        path: "/DataStatisticsPage/DataDetail",
        query: {
          uuid: item.uuid,
          name: item.questionnaireName,
          questionnaireType: item.questionnaireType,
        },
      });
    },
    // 发布问卷
    fbClick(item) {
      this.$confirm(
        "当前问卷处于可编辑状态，尚未发布，是否确认现在发布？",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        },
      )
        .then(() => {
          usercloseQuestionnaire({
            uuid: item.uuid,
          }).then((res) => {
            if (res.code === 200) {
              this.getData();
              this.$message.closeAll();
              this.$message({
                message: "成功",
                type: "success",
              });
            } else {
              this.$message.error("失败");
            }
          });
        })
        .catch(() => {});
    },
    copyClick() {
      // 复制逻辑
      console.log("复制链接");
      // 复制逻辑
      const input = document.createElement("input");
      input.value = this.clickItem.qrCode;
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);
      this.$message.success("复制成功");
    },

    downloadIamge(imgsrc, name) {
      //下载图片地址和图片名
      var image = new Image();
      // 解决跨域 Canvas 污染问题
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = function () {
        var canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        var context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);
        var url = canvas.toDataURL("image/png"); //得到图片的base64编码数据
        var a = document.createElement("a"); // 生成一个a元素
        var event = new MouseEvent("click"); // 创建一个单击事件
        a.download = name || "photo"; // 设置图片名称
        a.href = url; // 将生成的URL设置为a.href属性
        a.dispatchEvent(event); // 触发a的单击事件
      };
      image.src = imgsrc;
    },
    downs() {
      this.downloadIamge(this.clickItem.qrCode, "二维码");
    },
    handleExportClick(e, t) {
      // if (e.dataNum === 0) {
      // 	this.$message.closeAll();
      // 	this.$message({
      // 		type: "error",
      // 		message: "暂无数据",
      // 	});
      // 	return;
      // }

      if (t === "数据文件") {
        exportData({
          uuid: e.uuid,
        })
          .then((res) => {
            if (res.code === 200) {
              this.$message.closeAll();
              this.$message({
                type: "success",
                message: "导出成功",
              });

              const fileUrl = res.msg;

              const a = document.createElement("a");
              a.href = fileUrl;
              a.download = "";
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
            } else {
              this.$message.closeAll();
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
          })
          .catch((err) => {
            console.error("导出失败:", err);
            this.$message.closeAll();
            this.$message({
              type: "error",
              message: "导出异常",
            });
          });
      } else if (t === "腾讯文档") {
        this.listShow = false;
        this.optionShow = true;
        this.selectedOption = "";
        this.tencentTitle = "添加";
        const ifTencentDocs = localStorage.getItem("ifTencentDocs");
        this.tencentItem = e;
        if (ifTencentDocs != "1") {
          getConfiguration({
            appid: this.$store.getters.getAppId,
          }).then((res) => {
            if (res.code === 200) {
              window.open(res.msg, "_blank");
              setTimeout(() => {
                this.dialogVerifyVisible = true;
              });
            }
          });
        } else {
          this.tencentDocFileId = e.tencentDocFileId;
          this.selected = this.tencentDocFileId;
          this.dialogTencentVisible = true;
        }
      } else if (t === "飞书文档") {
        this.selectedOptionFeiShu = "";
        this.listShowFeiShu = false;
        this.optionShowFeiShu = true;
        this.selectedOptionFeiShu = "";
        this.feiShuItem = e;
        const ifFeiShuDocs = localStorage.getItem("ifFeiShuDocs");
        if (ifFeiShuDocs != "1") {
          getFeiShuConfiguration({
            appid: this.$store.getters.getAppId,
          }).then((res) => {
            if (res.code === 200) {
              window.open(res.msg, "_blank");
              setTimeout(() => {
                this.dialogVerifyVisibleFeiShu = true;
              });
            }
          });
        } else {
          this.feishuDocFileId = e.feishuDocFileId;
          this.selectedFeiShu = this.feishuDocFileId;
          this.dialogFeiShuVisible = true;
        }
      }
    },
    toggleOption(type) {
      if (this.selectedOption === type) {
        this.selectedOption = "";
      } else {
        this.selectedOption = type;
      }
    },
    optionConfirm() {
      if (this.selectedOption === "new") {
        this.optionConfirmDisabled = true;
        const formData = new FormData();
        formData.append("uuid", this.tencentItem.uuid);

        createByUuid(formData)
          .then((res) => {
            if (res.code === 200) {
              this.dialogTencentVisible = false;
              this.$message({
                message: "导出成功，请前往腾讯文档查看。",
                type: "success",
              });
              setTimeout(() => {
                this.optionConfirmDisabled = false;
              }, 50);

              this.getData();
            } else {
              console.log("导出错误:", res);
            }
          })
          .catch((err) => {
            console.error("导出失败:", err);
            setTimeout(() => {
              this.optionConfirmDisabled = false;
            }, 50);
          });
      } else if (this.selectedOption === "old") {
        this.optionConfirmDisabled = true;
        this.optionShow = false;
        this.listShow = true;
        this.tencentTitle = "文件列表";
        this.loadMore();
        setTimeout(() => {
          this.optionConfirmDisabled = false;
        }, 50);
      }
    },
    loadMore() {
      if (this.loading || !this.hasMore) return;

      this.loading = true;

      files({
        start: this.start,
      })
        .then((res) => {
          if (res.code === 200) {
            const list = res.data.list || [];
            const next = res.data.next;

            this.allList = this.allList.concat(list);

            this.start = next;

            if (next === 0) {
              this.hasMore = false;
            }
          } else {
            this.$message.closeAll();
            this.$message({
              message: res.msg,
              type: "error",
            });
          }

          this.loading = false;
        })
        .catch((err) => {
          console.error("加载失败:", err);
          this.loading = false;

          this.$message({
            message: "加载失败，请稍后重试",
            type: "error",
          });
        });
    },
    listConfirm() {
      if (this.listConfirmDisabled) return;
      if (!this.tencentItem.uuid) {
        ElMessage.error("请选择腾讯文档项目");
        return;
      }
      if (!this.selected) {
        ElMessage.error("请选择文件");
        return;
      }

      this.listConfirmDisabled = true;
      const formData = new FormData();
      formData.append("uuid", this.tencentItem.uuid);
      formData.append("fileId", this.selected);

      appendByUuid(formData)
        .then((res) => {
          if (res.code === 200) {
            this.dialogTencentVisible = false;
            this.$message({
              message: "导出成功，请前往腾讯文档查看。",
              type: "success",
            });
            setTimeout(() => {
              this.listConfirmDisabled = false;
            }, 50);

            this.getData();
          }
        })
        .catch((err) => {
          console.error("导出失败:", err);
          setTimeout(() => {
            this.listConfirmDisabled = false;
          }, 50);
        });
    },
    onCloseTencentDialog() {
      this.start = 0;
      this.hasMore = true;
      this.allList = [];
      this.loading = false;
      this.selected = "";
    },
    optionExit() {
      exit()
        .then((res) => {
          if (res.code === 200) {
            this.dialogTencentVisible = false;
            this.$message({
              type: "success",
              message: "退出成功",
            });
            window.location.reload();
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: "导出异常",
          });
        });
    },
    onCloseVerifyDialog() {
      this.dialogVerifyVisible = false;
      window.location.reload();
    },
    optionFeiShuExit() {
      exitFeiShu()
        .then((res) => {
          if (res.code === 200) {
            this.dialogFeiShuVisible = false;
            this.$message({
              type: "success",
              message: "退出成功",
            });
            window.location.reload();
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: "导出异常",
          });
        });
    },
    optionConfirmFeiShu() {
      console.log("---------飞书导出-----------");
      if (this.selectedOptionFeiShu === "new") {
        this.optionConfirmDisabledFeiShu = true;
        const formData = new FormData();
        formData.append("uuid", this.feiShuItem.uuid);

        createByUuidFeiShu(formData)
          .then((res) => {
            if (res.code === 200) {
              this.dialogFeiShuVisible = false;
              this.$message({
                message: "导出成功，请前往飞书文档查看。",
                type: "success",
              });
              setTimeout(() => {
                this.optionConfirmDisabledFeiShu = false;
              }, 50);

              this.getData();
            } else {
              console.log("导出错误:", res);
            }
          })
          .catch((err) => {
            console.error("导出失败:", err);
            setTimeout(() => {
              this.optionConfirmDisabledFeiShu = false;
            }, 50);
          });
      } else if (this.selectedOptionFeiShu === "old") {
        this.optionConfirmDisabledFeiShu = true;
        this.optionShowFeiShu = false;
        this.listShowFeiShu = true;
        this.tencentTitle = "文件列表";
        this.loadMoreFeiShu();
        setTimeout(() => {
          this.optionConfirmDisabledFeiShu = false;
        }, 50);
      }
    },

    loadMoreFeiShu() {
      if (this.loadingFeiShu || !this.hasMoreFeiShu) return;

      this.loadingFeiShu = true;

      filesFeiShu({
        start: this.startFeiShu,
      })
        .then((res) => {
          if (res.code === 200) {
            const list = res.data.files || [];
            const next = res.data.next;

            this.allListFeiShu = this.allListFeiShu.concat(list);

            this.startFeiShu = next;

            if (next === 0) {
              this.hasMoreFeiShu = false;
            }
          } else {
            this.$message.closeAll();
            this.$message({
              message: res.msg,
              type: "error",
            });
          }

          this.loadingFeiShu = false;
        })
        .catch((err) => {
          console.error("加载失败:", err);
          this.loadingFeiShu = false;

          this.$message({
            message: "加载失败，请稍后重试",
            type: "error",
          });
        });
    },
    listConfirmFeiShu() {
      if (this.listConfirmDisabledFeiShu) return;
      if (!this.feiShuItem.uuid) {
        ElMessage.error("请选择飞书文档项目");
        return;
      }
      if (!this.selectedFeiShu) {
        ElMessage.error("请选择文件");
        return;
      }

      this.listConfirmDisabledFeiShu = true;
      const formData = new FormData();
      formData.append("uuid", this.feiShuItem.uuid);
      formData.append("fileId", this.selectedFeiShu);

      appendByUuidFeiShu(formData)
        .then((res) => {
          if (res.code === 200) {
            this.dialogTencentVisibleFeiShu = false;
            this.$message({
              message: "导出成功，请前往飞书文档查看。",
              type: "success",
            });
            setTimeout(() => {
              this.listConfirmDisabledFeiShu = false;
            }, 50);

            this.getData();
          }
        })
        .catch((err) => {
          console.error("导出失败:", err);
          setTimeout(() => {
            this.listConfirmDisabledFeiShu = false;
          }, 50);
        });
    },

    toggleOptionFeiShu(type) {
      if (this.selectedOptionFeiShu === type) {
        this.selectedOptionFeiShu = "";
      } else {
        this.selectedOptionFeiShu = type;
      }
    },
    onCloseTencentDialogFeiShu() {
      this.startFeiShu = 0;
      this.hasMoreFeiShu = true;
      this.allListFeiShu = [];
      this.loadingFeiShu = false;
      this.selectedFeiShu = "";
    },
    onCloseVerifyDialogFeiShu() {
      this.dialogVerifyVisibleFeiShu = false;
      window.location.reload();
    },
  },
};
</script>

<style scoped>
/* .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 240px;
} */

.huise {
  width: 100%;
  height: 100vh;
  background-color: rgba(000, 000, 000, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9;
}

.tanchuang {
  min-width: 397px;
  padding: 0 0 20px 0;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  flex-direction: column;
  background-color: #ffffff;
  position: relative;

  .el-icon-close {
    position: absolute;
    right: 13px;
    top: 18px;
    cursor: pointer;
  }

  .top1 {
    width: 100%;
    height: 50px;
    background-color: #eaeaea;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 17px;
  }

  .content1 {
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 0 40px;
    box-sizing: border-box;

    .allview {
      display: flex;
      align-items: flex-start;
      margin-bottom: 17px;

      span {
        display: block;
        width: 95px;
        font-size: 16px;
        color: #6a6a6a;
        text-align: end;
      }

      .el-input {
        width: 196px;
        height: 30px;
      }

      div {
        font-size: 16px;
        color: #6a6a6a;
      }
    }
  }

  .el-button {
    background-color: #086ed9;
    color: #ffffff;
    cursor: pointer;
  }
}

.bigcontent {
  width: 100%;
  /* min-width: 1000px; */
  /* padding: 10px; */
  box-sizing: border-box;
  /* margin-top: 35px; */
  /* padding: 0; */
  height: 100%;
  overflow: hidden;
  overflow-y: auto;

  .top {
    /* // width: 100%; */
    background-color: #ffffff;
    padding: 18px 20px 20px 20px;
    margin: 0;

    .topfirst {
      display: flex;
      align-items: center;

      .inpstyle {
        display: flex;
        align-items: center;
        margin-right: 30px;

        span {
          display: block;
          width: 70px;
          font-size: 14px;
          color: #2f4257;
          margin-bottom: 3px;
        }

        /* .el-input {
          width: 240px;
          border: 1px solid #e6e6e6;

          .el-input__inner {
            border: none;
          }
        }

        .el-select {
          width: 240px;
        } */
      }
    }
  }

  .content {
    /* padding: 13px; */
    box-sizing: border-box;
    background-color: #ffffff;
    overflow: hidden;
    width: 100%;
    padding: 0 15px;

    .isReleaseTrue {
      background: #fea951;
      border-radius: 10px;
      padding: 5px 8px;
      color: #fff;
    }

    .isReleaseFalse {
      background: #d8d8d8;
      border-radius: 10px;
      padding: 5px 8px;
      color: #fff;
    }

    .custom-questionnaire-column {
      .cell {
        padding-left: 20px;
      }
    }
  }
}

.betweenFlx {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.columnFlx {
  /* display: flex;
  flex-direction: column; */
}

.flexStart {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.el-pagination {
  float: right;
}

.el-table .el-table__header-wrapper th,
.el-table .el-table__fixed-header-wrapper th {
  background-color: #edf2fa;
}

.el-drawer__container {
  position: relative;
  top: 200px;
  right: 40%;
}

/* // 弹窗样式 */
.bigcontent1 {
  width: 100%;
  height: 420px;
  padding: 10px;
  box-sizing: border-box;

  .alldiv {
    background-color: #ffffff;
    padding: 18px;
    box-sizing: border-box;
    height: 420px;
    overflow: auto;
  }

  .biao {
    width: 100%;
    display: flex;
    align-items: center;

    span {
      display: block;
      width: 5px;
      height: 14px;
      background-color: #5174f0;
      border-radius: 2px;
      margin-right: 10px;
    }

    h2 {
      font-size: 16px;
      color: #0f0f0f;
    }
  }

  .allinp {
    padding: 10px 20px;
    box-sizing: border-box;
    display: flex;
    align-items: center;

    .inpstyle {
      min-width: 240px;
      display: flex;
      flex-direction: column;
      margin-right: 30px;

      span {
        font-size: 16px;
        color: #2f4257;
        margin-bottom: 3px;
      }

      el-input {
        width: 100%;
      }
    }

    .selBiao {
      font-size: 16px;
      margin-right: 10px;
      font-weight: 600;
    }

    .selStyle {
      display: flex;
      align-items: center;
      margin-bottom: 10px;

      span {
        font-size: 14px;
        color: #0f0f0f;
        margin-right: 10px;
      }
    }
  }

  .message {
    span {
      font-size: 14px;
      color: #5174f0;
      margin-bottom: 12px;
      cursor: pointer;
    }
  }

  .footer {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
  }
}

.left-panel {
  /* // flex: 1; */
  background: #007aff;
  color: white;
  border-radius: 10px;
  padding: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.logo {
  width: 120px;
  margin-bottom: 15px;
}

.beta {
  background: yellow;
  color: black;
  padding: 5px 10px;
  border-radius: 3px;
  margin-bottom: 20px;
}

.title {
  font-size: 36px;
  margin-bottom: 30px;
}

.card {
  background: white;
  color: #007aff;
  padding: 25px;
  border-radius: 8px;
  text-align: center;
  margin-bottom: 20px;
}

.card-title {
  font-size: 24px;
  margin-bottom: 15px;
}

.qr-code {
  width: 180px;
}

.footer {
  display: flex;
  align-items: center;
  margin-top: auto;
}

.mini-logo {
  width: 40px;
  margin-right: 10px;
}

.right-panel {
  flex: 1;
  padding-left: 40px;
}

.info-box,
.link-box {
  margin-bottom: 30px;
}

.info-title,
.link-title {
  color: #007aff;
  border-bottom: 2px solid #007aff;
  padding-bottom: 5px;
  margin-bottom: 15px;
}

.info-item {
  margin: 8px 0;
}

.link-input {
  width: 100%;
  padding: 10px;
  margin-bottom: 15px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.btn-group {
  display: flex;
  gap: 15px;
  margin-top: 10px;
}

.btn {
  background: #007aff;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
}

.close-btn {
  background: #007aff;
  color: white;
  border: none;
  padding: 12px 25px;
  border-radius: 4px;
  font-size: 16px;
}

.el-dropdown-link {
  cursor: pointer;
  color: #007aff;
}

.el-icon-arrow-down {
  font-size: 12px;
}

/deep/ .el-dialog__header {
  text-align: center;
  font-weight: bold;
}

/deep/ .el-icon-close {
  background: #8290a3;
  border-radius: 50%;
  padding: 2px;
}

/deep/ .el-icon-close:before {
  color: #fff;
}

.tencentOptionList {
  display: flex;
  flex-direction: column;
  gap: 5px;
  position: relative;
}

.tencentOptionList .item {
  width: 100%;
  border: 1px solid #f7f7f7;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 0;
  background: #f7f7f7;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-Semibold;
  font-weight: Semibold;
  color: #3a3a3c;
  cursor: pointer;
  gap: 18px;
}

.tencentOptionList .item img {
  width: 22px;
  height: 22px;
}

/* .tencentOptionList .item:hover {
		border: 1px solid #1877FF;
		color: #1877FF;
	} */

.tencentOptionList .item.active {
  border: 1px solid #1877ff;
  color: #1877ff;
}

.tencentOptionList .button {
  margin: 0 auto;
  margin-top: 15px;
  padding: 7px 0;
  width: 60%;
  background: #3a60ff;
  border: 1px solid #3a60ff;
  border-radius: 16px;
  text-align: center;
  color: #fff;
  font-weight: bold;
  cursor: pointer;
  position: relative;
}

@keyframes spin {
  0% {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  100% {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}

.tencentOptionList .button.disabled {
  color: #fff0;
}

.tencentOptionList .button.disabled::after {
  content: "";
  display: block;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: 3px solid #fff;
  border-top-color: #0000;
  animation: spin 0.4s linear infinite;
  position: absolute;
  left: 50%;
  top: 50%;
}

.tencentOptionList .exit {
  font-size: 10px;
  color: #3a60ff;
  text-align: right;
  text-decoration: underline;
  position: absolute;
  bottom: 0;
  right: -10px;
  cursor: pointer;
}

.tencentList .list .item {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.tencentList .list .no-data {
  text-align: center;
}

.tencentList .list .item + .item {
  margin-top: 10px;
}

.tencentList .list .item .left {
  display: flex;
  align-items: center;
  gap: 20px;
}

.tencentList .list .item .left .icon {
  width: 25px;
  height: 29px;
}

.tencentList .list .item .left .text {
  display: flex;
  flex-direction: column;
}

.tencentList .list .item .left .text .title {
  font-size: 14px;
  color: #333333;
  font-weight: bold;
  margin: 0;
}

.tencentList .list .item .left .text .time {
  font-size: 12px;
  color: #949eaf;
}

/deep/ .el-radio__label {
  display: none;
}

.tencentList .more {
  margin: 20px auto 0;
  text-align: center;
}

.tencentList .more button {
  background: none !important;
  border: none !important;
  color: #3a60ff;
}

.tencentList .button {
  margin: 0 auto;
  margin-top: 15px;
  padding: 7px 0;
  width: 60%;
  background: #3a60ff;
  border: 1px solid #3a60ff;
  border-radius: 16px;
  text-align: center;
  color: #fff;
  font-weight: bold;
  cursor: pointer;
  position: relative;
}

.tencentList .button.disabled {
  color: #fff0;
}

.tencentList .button.disabled::after {
  content: "";
  display: block;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: 3px solid #fff;
  border-top-color: #0000;
  animation: spin 0.4s linear infinite;
  position: absolute;
  left: 50%;
  top: 50%;
}

.visibleBotton {
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 50px;
}

.visibleBotton .button {
  font-size: 12px;
  font-family: PingFang SC, PingFang SC-Semibold;
  font-weight: Semibold;
  color: #3a3a3c;
  background: #ffffff;
  border: 1px solid #e2e2e2;
  border-radius: 25px;
  padding: 6px 30px;
  cursor: pointer;
}

.visibleBotton .button + .button {
  border: 1px solid #3a60ff;
  background: #3a60ff;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/DataStatisticsPage/index.vue